var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 256,
    viewBox: "0 0 235 256",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.666 256H29.334C13.1523 256 0 242.848 0 226.666V82.666C0 66.4844 13.1523 53.334 29.334 53.334H34.666C39.082 53.334 42.666 56.918 42.666 61.334C42.666 65.75 39.082 69.334 34.666 69.334H29.334C21.9844 69.334 16 75.3164 16 82.666V226.666C16 234.016 21.9844 240 29.334 240H162.666C170.016 240 176 234.016 176 226.666V221.334C176 216.918 179.584 213.334 184 213.334C188.416 213.334 192 216.918 192 221.334V226.666C192 242.848 178.848 256 162.666 256Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.334 192H205.334C221.516 192 234.666 178.848 234.666 162.666V29.334C234.666 13.1523 221.516 0 205.334 0H93.334C77.1523 0 64 13.1523 64 29.334V162.666C64 178.848 77.1523 192 93.334 192ZM80 29.334C80 21.9844 85.9844 16 93.334 16H205.334C212.684 16 218.666 21.9844 218.666 29.334V162.666C218.666 170.016 212.684 176 205.334 176H93.334C85.9844 176 80 170.016 80 162.666V29.334Z",
    fill: "#444444"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.58b281b6.svg";
export { ForwardRef as ReactComponent };